import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container, Table } from "reactstrap";
import "./OrderDetail.scss";
import timer from "../../../assets/images/timer.svg";
import orderImg from "../../../assets/images/orderProduct.png";
import minus from "../../../assets/images/Minus.svg";
import plus from "../../../assets/images/Plus.svg";
import profile from "../../../assets/images/userProfile.png";
import locations from "../../../assets/images/location.svg";
import money from "../../../assets/images/moneys.svg";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrderDetail,
  getActivies,
  updateOrder,
  updateOrderTime,
} from "live-slices/thunk";
import {
  updateOrderQuantityApi,
  updateProductAvailabiltyApi,
} from "live-slices/thunk";
import { createSelector } from "reselect";
import { toast, ToastContainer } from "react-toastify";
import ReasonModal from "./components/ReasonModal";
import ConfirmOrderModal from "./components/ConfirmOrderModal";
import FindModal from "./components/FindModal";
import VideoViewer from "Components/Common/VideoViewer";
import ayezakahn from "../../../assets/images/ayeza-khan-img.png";
import phoneIcon from "../../../assets/images/phone-icon.png";
import greendot from "../../../assets/images/green-active-tag.png";
import TrackOrderMOdal from "./components/TrackOrder";
import { Constant } from "utils/enums";
import ErrorModal from "Components/Common/ErrorModal";

const OrderDetail = (props: any) => {
  document.title = "Orders | BuyPass";
  const location = useLocation();
  const params = useParams();
  const dispatch: any = useDispatch();
  const orderId =
    location.state?.orderId ||
    params.id ||
    new URLSearchParams(location.search).get("orderId");

  const selecteOrderDetailData = createSelector(
    (state: any) => state.Orders,
    (orderDetail) => orderDetail?.orderDetail
  );
  const selecteOrderData = createSelector(
    (state: any) => state.Orders,
    (activies) => activies?.activies
  );

  const activities = useSelector(selecteOrderData);
  const [currentImage, setCurrentImage] = useState("");
  const orderInfo = useSelector(selecteOrderDetailData);
  const [orderDetail, setorderDetail] = useState<any>({});
  const [reasonModal, setReasonModal] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [findModal, setfindModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [selectedAvailableReason, setAvailableReason] = useState<string>("");
  const [trackOrderModal, setTrackOrderModal] = useState(false);
  const businessType:any= localStorage.getItem(Constant.seller)
  const type = JSON.parse(businessType)
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });


  useEffect(() => {
    dispatch(fetchOrderDetail(orderId));
    console.log(type)
  }, [orderId]);

  useEffect(() => {
    if (trackOrderModal) {
      dispatch(getActivies({ orderId: orderInfo._id }));
    }
  }, [trackOrderModal]);

  const onClickOrderStatus = async (
    orderId: string,
    status: string,
    setButtonLoading: React.Dispatch<React.SetStateAction<boolean>>,
    sellerCancellationReason?: string
  ) => {
    setButtonLoading(true);
    try {
      dispatch(updateOrderTime({ orderId, status, sellerCancellationReason }));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const updatedOrder = await dispatch(fetchOrderDetail(orderId));
      toast.success("Status Updated.", { autoClose: 1000 });
      setorderDetail(updatedOrder?.payload);
      setButtonLoading(false);
    } catch (error) {
      setButtonLoading(false);
      toast.error("Status Failed.", { autoClose: 1000 });
      console.error("Error updating order status:", error);
    } finally {
      setButtonLoading(false);
    }
  };

  const onClickOrderTimingChange = async (
    orderId: string,
    status: string,
    setButtonLoading: React.Dispatch<React.SetStateAction<boolean>>,
    preparingTime?: any
  ) => {
    setButtonLoading(true);
    try {
      dispatch(updateOrderTime({ orderId, status, preparingTime }));
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const updatedOrder = await dispatch(fetchOrderDetail(orderId));
      toast.success("Status Updated.", { autoClose: 1000 });
      setorderDetail(updatedOrder?.payload);
      setButtonLoading(false);
    } catch (error) {
      setButtonLoading(false);
      toast.error("Status Failed.", { autoClose: 1000 });
      console.error("Error updating order status:", error);
    } finally {
      setButtonLoading(false);
    }
  };

  const handleAcceptClick = (orderId: string) => {
    localStorage.setItem("orderAccepted", orderId);
    setTimeout(() => localStorage.removeItem("orderAccepted"), 1000);
    setSelectedOrderId(orderId);
    setConfirmModal(true);
  };

  const handleToggleChange = (e: any, item: any) => {
    if (e.target.checked) {
      dispatch(
        updateProductAvailabiltyApi({
          orderId: orderInfo._id,
          productId: item.productId,
          sellerCancellationReason: "",
        })
      );
    } else {
      setSelectedItem(item);
      setfindModal(true);
    }
  };

  const handleConfirmOrder = async (selectedTime: string) => {
    if (selectedOrderId) {
      await onClickOrderTimingChange(
        selectedOrderId,
        "orderAccepted",
        setAcceptLoading,
        selectedTime
      );
    }
    setConfirmModal(false);
  };

  const handleReasonSubmit = () => {
    if (!selectedReason) {
      alert("Please select a reason for rejection.");
      return;
    }
    onClickOrderStatus(
      orderInfo._id,
      "cancelledBySeller",
      setRejectLoading,
      selectedReason
    );
    setReasonModal(false);
    setSelectedReason("");
  };

  const handleRejectClick = () => {
    if (orderInfo?._id) {
      localStorage.setItem("orderAccepted", orderInfo._id);
      setTimeout(() => localStorage.removeItem("orderAccepted"), 1000);
    }
    setReasonModal(true);
  };

  var [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());
  }, [orderInfo?.preparingTime, orderInfo?.orderAcceptTime]);

  const calculateTimeLeft = () => {
    if (orderInfo?.preparingTime === 0 && orderInfo?.status === "orderPlaced") {
      const now = Date.now();
      const diff = Math.max(orderInfo?.orderAcceptTime - now, 0);
      return Math.floor(diff / 1000);
    } else {
      const now = Date.now();
      const diff = Math.max(orderInfo?.preparingTime - now, 0);
      return Math.floor(diff / 1000);
    }
  };

  useEffect(() => {
    if (timeLeft === null || timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    } else {
      return `${minutes}:${String(secs).padStart(2, "0")}`;
    }
  };

  const handleDecreaseQuantity = async (order: any, productId: any) => {
    if (order > 1) {
      const updatedOrder = {
        orderId: orderInfo._id,
        productId: productId,
        quantity: order - 1,
      };

      try {
        const response = await dispatch(updateOrderQuantityApi(updatedOrder));
        if (response) {
          dispatch(fetchOrderDetail(orderId));
        }
      } catch (error) {
        console.error("API Error:", error);
        toast.error("Failed to update quantity!", { autoClose: 1000 });
      }
    } else {
      toast.error("Quantity cannot be less than 1", { autoClose: 1000 });
    }
  };

  const handleSubmit = () => {
    if (!selectedItem || !selectedAvailableReason) return;
    dispatch(
      updateProductAvailabiltyApi({
        orderId: orderInfo._id,
        productId: selectedItem.productId,
        reason: selectedAvailableReason,
      })
    )
      .then(() => {
        dispatch(fetchOrderDetail(orderId));
      })
      .catch((error: any) => {
        toast.error(error, { autoClose: 1000 });
      });

    setfindModal(false);
    setSelectedReason("");
  };
  const openViewer = (videoUrl: string) => {
    setCurrentImage(videoUrl);
    setViewerOpen(true);
  };
  const closeViewer = () => {
    setViewerOpen(false);
  };

  const handleIncreaseQuantity = async (order: number, productId: any, maxQuantity: number) => {
    if (order >= maxQuantity) {
      toast.error(`Maximum quantity limit reached (${maxQuantity})`, { autoClose: 1000 });
      return;
    }
    const updatedOrder = {
      orderId: orderInfo._id,
      productId: productId,
      quantity: order + 1,
    };

    try {
      const response = await dispatch(updateOrderQuantityApi(updatedOrder));
      if (response) {
        dispatch(fetchOrderDetail(orderInfo._id));
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to update quantity!", { autoClose: 1000 });
    }
  };

  const formatStatus = (status: any) => {
    if (!status) return "Unknown Status";

    return status
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str: any) => str.toUpperCase());
  };

  const formattedStatus = formatStatus(orderInfo?.status);


  return (
    <div className="page-content orderDetailMainPage">
      <ToastContainer />
      <Container fluid>
        <BreadCrumb
          title="Order Details"
          pageTitle="Orders"
          pageTitleRoute="/manage-orders"
        />
        <ReasonModal
          show={reasonModal}
          onCloseClick={() => setReasonModal(false)}
          onSubmit={handleReasonSubmit}
          selectedReason={selectedReason}
          setSelectedReason={setSelectedReason}
        />
        <VideoViewer
          isOpen={isViewerOpen}
          videoUrl={currentImage}
          toggle={closeViewer}
        />
        <FindModal
          show={findModal}
          onCloseClick={() => setfindModal(false)}
          onSubmit={handleSubmit}
          selectedAvailableReason={selectedAvailableReason}
          setAvailableReason={setAvailableReason}
        />
        <ConfirmOrderModal
          show={confirmModal}
          onCloseClick={setConfirmModal}
          onConfirm={handleConfirmOrder}
          orderDetail={orderInfo}
        />
        <ErrorModal
          show={showModal.isVisible}
          message={errorMessage}
          color={showModal.color}
          onCloseClick={() => setShowModal({ isVisible: false, color: false })}
        />
        <TrackOrderMOdal
          show={trackOrderModal}
          onCloseClick={() => setTrackOrderModal(false)}
          activities={activities}
          order={orderInfo}
        />
        <div className="mainLayoutOrderDetail">
          <div className="tableDataCol">
            <Card className="topCArd">
              <div className="orderDetailRow">
                <div className="orderId">
                  <h3>🛒 #{orderInfo?.buypassId}</h3>
                  <div className="thisOrder">
                    <div className="statusDv">
                      <div className="dot"></div>
                      <p style={{ textTransform: "capitalize" }}>
                        {formattedStatus}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="orderStutes">
                  {(timeLeft !== 0 && (orderInfo?.status === "orderAccepted" || orderInfo?.status === "orderPlaced")) && (
                    <div className="timingDv">
                      <img src={timer} alt="" />
                      <h4>
                        {formatTime(timeLeft ? timeLeft : 0)} <span>left</span>
                      </h4>
                    </div>
                  )}
                  {orderInfo?.status === "cancelledBySeller" ||
                    (orderInfo?.status === "cancelledBySeller" && (
                      <>
                        <button
                          type="button"
                          className="btn btn-secondary acceptBtn"
                          data-testing-id="acceptButton"
                          disabled={orderInfo?.items?.every((item: { isAvailable: boolean }) => !item.isAvailable)}
                          onClick={() => handleAcceptClick(orderInfo._id)}
                        >
                          Accept
                        </button>
                        <button
                          type="button"
                          className="btn  rejectBtn"
                          data-testing-id="rejectButton"
                          onClick={handleRejectClick}
                        >
                          Reject
                        </button>
                      </>
                    ))}
                  {orderInfo?.status === "orderAccepted" ||
                    orderInfo?.status === "pending" ||
                    (orderInfo?.status === "orderPlaced" && (
                      <>
                        <button
                          type="button"
                          className="btn btn-secondary acceptBtn"
                          data-testing-id="acceptButton"
                          onClick={() => handleAcceptClick(orderInfo._id)}
                          disabled={orderInfo?.items?.every((item: { isAvailable: boolean }) => !item.isAvailable)}
                        >
                          Accept
                        </button>
                        <button
                          type="button"
                          data-testing-id="rejectButton"
                          className="btn btn-secondary rejectBtn"
                          onClick={handleRejectClick}
                        >
                          Reject
                        </button>
                      </>
                    ))}
                </div>
              </div>
              <div className="tableDv">
                <Table>
                  <thead>
                    <tr>
                      <th colSpan={1}>Image</th>
                      <th colSpan={2}>Product Name</th>
                      <th colSpan={1}>Variants</th>
                      <th colSpan={1}>SKU</th>
                      <th colSpan={1}>Quantity</th>
                      <th colSpan={3}>Unit Price</th>
                      <th colSpan={2}>Subtotal</th>
                      <th colSpan={1}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderInfo?.items?.map((item: any, index: number) => (
                      <tr key={index}>
                        <td colSpan={1}>
                          <img
                            src={item.productImage}
                            className="productImage"
                            alt=""
                          />
                        </td>
                        <td colSpan={2}>
                          <h4>{item.productName}</h4>
                        </td>
                        <td colSpan={1}>
                          <h4>
                            {item.variants
                              .map((variant: any) => `${variant.value.name}`)
                              .join(", ")}
                          </h4>
                        </td>
                        <td colSpan={1}>
                          <h4>{item.sku}</h4>
                        </td>
                        <td colSpan={1}>
                          <div className="quantityDv">
                            <button
                              onClick={() =>
                                handleDecreaseQuantity(
                                  item.quantity,
                                  item.productId
                                )
                              }
                              disabled={orderInfo.status !== "orderPlaced"}
                              style={{
                                background: "none",
                                border: "none",
                                padding: "0px",
                              }}
                            >

                              <i className='bx bx-minus plusDVV' style={{
                                backgroundColor:
                                  item.quantity <= 1
                                    ? "#83bbff"
                                    : orderInfo.status !== "orderPlaced"
                                      ? "#83bbff"
                                      : "#0877FF",
                                padding: "1px",
                                borderRadius: "4px",
                              }}></i>
                            </button>
                            <h3>{item.quantity}</h3>
                            <button
                              onClick={() => handleIncreaseQuantity(item.quantity, item.productId, item.ordignalQuantity)}
                              disabled={orderInfo.status !== "orderPlaced"}
                              style={{
                                background: "none",
                                border: "none",
                                padding: "0px",
                              }}
                            >
                              <i className='bx bx-plus plusDVV' style={{
                                backgroundColor:
                                  item.quantity >= item.ordignalQuantity
                                    ? "#83bbff"
                                    : orderInfo.status !== "orderPlaced"
                                      ? "#83bbff"
                                      : "#0877FF",
                                padding: "1px",
                                borderRadius: "4px",
                              }}></i>
                            </button>
                          </div>
                        </td>
                        <td colSpan={3}>
                          {/* <h4>Rs {item?.individualSummary?.productPrice|| item.price.toLocaleString("en-IN") || 0}</h4> */}
                          <h4>
                            Rs{" "}
                            {Number.isFinite(item?.individualSummary?.productPrice)
                              ? Math.ceil(item.individualSummary.productPrice)
                              : Number.isFinite(item?.price)
                                ? Math.ceil(item.price)
                                : "0"}
                          </h4>



                        </td>
                        <td colSpan={2}>
                          {/* <h4 className="fw-bold">Rs {item?.overallItemSummary?.productPrice||(item?.price * item?.ordignalQuantity).toLocaleString("en-IN")}</h4> */}
                          <h4 className="fw-bold">
                            Rs{" "}
                            {Number.isFinite(item?.overallItemSummary?.productPrice)
                              ? Math.ceil(item.overallItemSummary.productPrice)
                              : Number.isFinite(item?.price) && Number.isFinite(item?.ordignalQuantity)
                                ? Math.ceil(item.price * item.ordignalQuantity)
                                : "0"}
                          </h4>




                        </td>
                        <td colSpan={1}>
                          <div className="toggleDv">
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                data-testing-id="toggleActive"
                                type="checkbox"
                                checked={item.isAvailable}
                                onChange={(e) => handleToggleChange(e, item)}
                                disabled={orderInfo.status !== "orderPlaced"}
                              />
                              <label
                                className={`p-0 m-0  toggleLabel ${!item.isAvailable ? "text-danger" : ""
                                  }`}
                              >
                                {item.isAvailable ? "Available" : item.productUnavailablityReason}
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>


              <div className="orderlistDv">
                {orderInfo?.items?.map((item: any, index: number) => (
                  <div key={index} className={`orderListItem ${!item.isAvailable ? "RedColourProduct" : ""}`}>



                    <div className="order-detail-row">
                      <figure>
                        <img src={item.productImage} className="productImage" alt="" />
                      </figure>
                      <div className="order-detail">
                        <p>{item.productName} <span>({item.sku})</span></p>
                        {item.variants.length > 0 && (
                          <p className="variants"><span>{item.variants.map((variant: any) => `${variant.value.name}`).join("</span><span>")}</span></p>
                        )}
                        <p className="qty-box"><button
                          onClick={() => handleDecreaseQuantity(item.quantity, item.productId)}
                          disabled={orderInfo.status !== "orderPlaced"}
                          style={{ background: "none", border: "none", padding: "0px", }}
                        >
                          <i className='bx bx-minus plusDVV' style={{ backgroundColor: item.quantity <= 1 ? "#83bbff" : orderInfo.status !== "orderPlaced" ? "#83bbff" : "#0877FF", padding: "1px", borderRadius: "4px", }}></i>
                        </button>
                          <strong>{item.quantity}</strong>
                          <button
                            onClick={() => handleIncreaseQuantity(item.quantity, item.productId, item.ordignalQuantity)}
                            disabled={orderInfo.status !== "orderPlaced"}
                            style={{ background: "none", border: "none", padding: "0px", }} >
                            <i className='bx bx-plus plusDVV' style={{ backgroundColor: item.quantity >= item.ordignalQuantity ? "#83bbff" : orderInfo.status !== "orderPlaced" ? "#83bbff" : "#0877FF", padding: "1px", borderRadius: "4px", }}></i>
                          </button></p>
                        <div className="toggleDv">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              data-testing-id="toggleActive"
                              type="checkbox"
                              checked={item.isAvailable}
                              onChange={(e) => handleToggleChange(e, item)}
                              disabled={orderInfo.status !== "orderPlaced"}
                            />
                            <label
                              className={`p-0 m-0 ms-2 toggleLabel ${!item.isAvailable ? "text-danger" : ""
                                }`}
                            >
                              {item.isAvailable ? "Available" : item.productUnavailablityReason}
                            </label>
                          </div>
                        </div>

                      </div>
                    </div>
                    {/* <div className="order-sub-detail-row sub-total"><h4>Rs {item.price.toLocaleString("en-IN")} x {item.quantity}</h4> <span>Rs {((item?.price || 0) * (item?.quantity || 0)).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div> */}
                    <div className="order-sub-detail-row sub-total">
                      <h4>
                        Rs{" "}
                        {Number.isFinite(item?.price) ? Math.ceil(item.price) : "0"} x{" "}
                        {Number.isFinite(item?.quantity) ? Math.ceil(item.quantity) : "0"}
                      </h4>

                      <span>
                        Rs{" "}
                        {Number.isFinite(item?.price) && Number.isFinite(item?.quantity)
                          ? Math.ceil(item.price * item.quantity)
                          : "0"}
                      </span>
                    </div>



                  </div>
                ))}
              </div>


            </Card>
            <Card className="bottomCArd">
              <div className="bottomData">
                {orderInfo?.sellerCancellationReason && (
                  <div className="rowData">
                    <p>Cancellation Reason:</p>
                    <div className="lastDv">
                      <p>{orderInfo?.sellerCancellationReason}</p>
                    </div>
                  </div>
                )}

                {/* <div className="rowData">
                                    <p>Adjust Amount:</p>
                                    <div className='lastDv'>
                                        <p>Rs 4199.00</p>
                                    </div>
                                </div> */}
                {/* <div className="rowData">
                  <p>Shipping Charges:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.shippingfee.toLocaleString("en-IN") || 0 }</p>
                  </div>
                </div> */}
                {/* <div className="rowData">
                  <p>
                  Discount <span className=" text-secondary">(Buypass):</span>
                  </p>
                  <div className="lastDv">
                  <p>Rs {orderInfo?.orderSummary?.discount}</p>
                  </div>
                  </div> */}
                {orderInfo?.orderSummary?.subTotal === 0 ? ("") : (
                  <div className="rowData">
                    <p>Sub total:</p>
                    <div className="lastDv">
                      <p>
                        Rs{" "}
                        {Number.isFinite(orderInfo?.orderSummary?.subTotal)
                          ? Math.ceil(orderInfo.orderSummary.subTotal)
                          : "N/A"}
                      </p>


                    </div>
                  </div>
                )}
                {orderInfo?.orderSummary?.total === 0 ? ("") : (
                  <div className="rowData">
                    <p>Total:</p>
                    <div className="lastDv">
                      <p>
                        Rs{" "}
                        {Number.isFinite(orderInfo?.orderSummary?.total)
                          ? Math.ceil(orderInfo.orderSummary.total)
                          // .toLocaleString("en-US", {
                          //   minimumFractionDigits: 2,
                          //   maximumFractionDigits: 2,
                          // })s
                          : "N/A"}
                      </p>


                    </div>
                  </div>
                )}

                {[
                  { label: "Adjustment Fee", key: "adjustmentPrice" },
                  { label: "Buypass Profit", key: "buypassProfit" },
                  { label: "BP Commission", key: "commission" },
                  { label: "Cash Handling Fee", key: "cashHandlingFee" },
                  { label: "Package Handling Fee", key: "packageHandling" },
                  { label: "Tax Fee", key: "tax" },
                  { label: "Shipping Fee", key: "shippingfee" },
                  { label: "VAT", key: "vat" },
                ].map((item) => {
                  const value = orderInfo?.orderSummary?.[item.key];
                  const isNumber = typeof value === "number";

                  return (
                    value === 0 ? ("") : (
                      <div className="rowData" key={item.key}>
                        <p>{item.label}:</p>
                        <div className="lastDv">
                          <p>
                            {isNumber
                              ? value === 0
                                ? "Rs 0"
                                : "Rs - " + Math.ceil(value)
                              : ""}
                          </p>


                        </div>
                      </div>
                    )

                  );
                })}
                {orderInfo?.orderSummary?.sellerPrice === 0 ? ("") : (
                  <div className="rowData">
                    <h3>Grand Total</h3>
                    <div className="lastDv">
                      <h3>
                        Rs{" "}
                        {Number.isFinite(orderInfo?.orderSummary?.sellerPrice)
                          ? Math.ceil(orderInfo.orderSummary.sellerPrice)
                          : Number.isFinite(orderInfo?.orderSummary?.total)
                            ? Math.ceil(orderInfo.orderSummary.total)
                            : "0"}
                      </h3>


                    </div>
                  </div>
                )}

                {/* <div className="rowData">
                  <p>Buypass Profit:</p>
                  <div className="lastDv">
                    <p>Rs {"-"+ orderInfo?.orderSummary?.buypassProfit || 0}</p>
                  </div>
                </div> */}



                {/* <div className="rowData">
                  <p>Cash Handling Fee:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.cashHandlingFee.toLocaleString("en-IN")}</p>
                  </div>
                </div> */}
                {/* <div className="rowData">
                  <p>Penalty:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.penalty.toLocaleString("en-IN")}</p>
                  </div>
                </div>
                <div className="rowData">
                  <p>Returns:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.returns.toLocaleString("en-IN")}</p>
                  </div>
                </div>
                       <div className="rowData">
                  <p>Total Deduction:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.otherDeduction.toLocaleString("en-IN")}</p>
                  </div>
                </div>
                <div className="rowData">
                  <p>Vat:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.vat}</p>
                  </div>
                </div>
                <div className="rowData">
                  <p>Adjust Amount:</p>
                  <div className="lastDv">
                    <p>Rs {orderInfo?.orderSummary?.adjustMentAmount || 0}</p>
                  </div>
                </div> */}
                {/* <div className="rowData">
                  <h3>Grand Total</h3>
                  <div className="lastDv">
                    <h3>
                      Rs {orderInfo?.orderSummary?.sellerPrice || orderInfo?.orderSummary?.total
                      }
                    </h3>
                  </div>

                </div> */}
                {/* <div className="rowData">
                  <p >Buypass Commission</p>
                  <div className="lastDv">
                    <p >- Rs
                      {`${orderInfo?.orderSummary?.buypassCommission || 0}`}</p>
                  </div>
                </div> */}
                {/* <div className="rowData">
                  <h6 className="finalCom">Final Amount</h6>
                  <div className="lastDv">
                  <h6 className="finalCom">
                      Rs{" "}
                      {orderInfo?.orderSummary?.total &&
                        orderInfo?.orderSummary?.buypassCommission
                        ? (
                          orderInfo?.orderSummary?.total - orderInfo?.orderSummary?.buypassCommission
                        )
                          .toLocaleString("en-IN")
                          .replace(/\.00$/, "")
                        : "0"}
                    </h6>
                  </div>
                </div> */}
              </div>
              {orderInfo && orderInfo?.assignRider && (
                <div className="card-box-main">
                  <div className="statusDv">
                    <div className="dot"></div>
                    <p style={{ textTransform: "capitalize" }}>
                      Assigned
                    </p>
                  </div>
                  <div className="rider-profile d-flex">
                    <div className="position">
                      <img src={orderInfo?.assignRider?.profilePicture?.url || ayezakahn} alt="" />
                      <img className="green-dot" src={greendot} alt="" />
                    </div>
                    <div>
                      <h1>{orderInfo?.assignRider?.name}</h1>
                      <div className="d-flex">
                        <img src={phoneIcon} alt="" />
                        <p>{orderInfo?.assignRider?.phoneNumber}</p>
                      </div>
                    </div>
                  </div>
                  <button className="trackOrderBtn" data-testgin-id="trackOrderButton_ManualOrderDetail"
                    onClick={() => setTrackOrderModal(true)}
                  >Track This Order</button>
                </div>
              )}
            </Card>
          </div>
          <div className="custemerDetailCol">
            {/* <Card className="cardDv">
              <div className="heading">
                <h5>Customer Details</h5>
              </div>
              <div className="bodyDv">
                <div className="profileDv">
                  <img src={orderInfo?.userDetails?.profilePicture?.url || profile} alt="" />
                  <div className="content">
                    <h5>{orderInfo?.userDetails?.name}</h5>
                    <p>Customer</p>
                  </div>
                </div>
              </div>
            </Card> */}
            {/* <Card className="cardDv">
              <div className="heading">
                <img src={locations} alt="" />
                <h5>Billing Address</h5>
              </div>
              <div className="bodyDv">
                <div className="profileDv">
                  <div className="content">
                    <h5>{orderInfo?.userDetails?.name}</h5>
                    <p style={{ marginBottom: '15px' }}>
                      {orderInfo?.address?.streetAddress}
                      <br></br>
                      {orderInfo?.address?.state}
                      <br></br>
                      {orderInfo?.address?.city}
                    </p>
                    <div>
                      <p className="phoneNum">Phone No: <h6>{orderInfo?.address?.phoneNumber}</h6></p>
                    </div>
                  </div>
                </div>
              </div>
            </Card> */}
            {/* <Card className="cardDv">
              <div className="heading">
                <img src={locations} alt="" />
                <h5>Shipping Address</h5>
              </div>
              <div className="bodyDv">
                <div className="profileDv">
                  <div className="content">
                    <h5>{orderInfo?.userDetails?.name}</h5>
                    <p >
                      {orderInfo?.address?.streetAddress}
                      <br></br>
                      {orderInfo?.address?.state}
                      <br></br>
                      {orderInfo?.address?.city}
                    </p>
                  </div>
                </div>
              </div>
            </Card> */}
            {/* <Card className='cardDv'>
                            <div className='heading'>
                                <img src={locations} alt="" />
                                <h5>Customer Details</h5>
                            </div>
                            <div className='bodyDv'>
                                <div className="profileDv">
                                    <div className='content'>
                                        <h5>Adeel</h5>
                                        <p>1234 Elm Street, Apt 567Los Angeles, CA 90001United States</p>
                                    </div>
                                </div>
                            </div>
                        </Card> */}

            <Card className="cardDv">
              <div className="heading">
                <img src={money} alt="" />
                <h5>Shipping Details</h5>
              </div>
              <div className="bodyDv">
                <div className="profileDv">
                  <div className="contentTow">
                     <div className="profileDv">
                  <img src={orderInfo?.userDetails?.profilePicture?.url || profile} alt="" />
                  <div className="content">
                    <h5>{orderInfo?.userDetails?.name}</h5>
                    <p>Customer</p>
                  </div>
                </div>
                    <div className="contentRow">
                      <p>Phone No:</p>
                      <h5 style={{marginTop:"2px",textTransform:"capitalize"}}> {orderInfo?.address?.phoneNumber} </h5>
                    </div>
                                <div className="contentRow" style={{ display: 'flex', alignItems: 'flex-start' }}>
  <p style={{ minWidth: '25px', margin: 0 }}>Address:</p>
 <h5
  style={{
    margin: 0,
    textTransform: 'capitalize',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    flex: 1,marginTop:"2px"
  }}
>
  {[
    orderInfo?.address?.streetAddress,
    orderInfo?.address?.area,
    orderInfo?.address?.neighbourhood,
    orderInfo?.address?.city,
    orderInfo?.address?.state,
  ]
    .filter(Boolean)
    .join(', ')}
</h5>
</div>
                    <div className="contentRow">
                      <p>Payment Method:</p>
                      <h5 style={{marginTop:"2px",textTransform:"capitalize"}}> {orderInfo?.paymentMethodData?.name} </h5>
                    </div>
                       <div className="contentRow">
                      <p>Total:</p>
                      <h5 style={{marginTop:"2px",textTransform:"capitalize"}}>  Rs{" "}
                        {Number.isFinite(orderInfo?.orderSummary?.total)
                          ? Math.ceil(orderInfo.orderSummary.total)
                          // .toLocaleString("en-US", {
                          //   minimumFractionDigits: 2,
                          //   maximumFractionDigits: 2,
                          // })s
                          : "N/A"}</h5>
                    </div>
                    {/* <div className="contentRow" style={{ flexWrap: 'nowrap' }}>
                      <p style={{ width: '158px' }}>Description:</p>
                      <h5 style={{ lineHeight: '1.4' }}>{orderInfo?.paymentMethodData?.description} </h5>
                    </div> */}
                  </div>
                </div>
              </div>
            </Card>
            {orderInfo?.orderPackageImage?.length > 0 && (
              <Card className="cardDv videoCard">
                <div className="heading">
                  <h5>Video Proof</h5>
                </div>
                <div className="bodyDv" style={{ display: 'flex' }}>
                  {orderInfo.orderPackageImage.map((video: any, index: number) => (
                    <video
                      key={index}
                      src={video?.url}
                      style={{ width: "100px", marginRight: "10px", cursor: "pointer", height: '100px' }}
                      onClick={() => openViewer(video?.url)}
                    />
                  ))}
                </div>
              </Card>
            )}
          </div>
        </div>
        <div className="order-detail-mobile-view" style={{ display: 'none' }}>

          <div className="widget">
            <div className="widget-header">
              <h5><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16.0668 2.4892H8.09663C4.63466 2.4892 2.5708 4.55306 2.5708 8.01502V15.9756C2.5708 19.4471 4.63466 21.511 8.09663 21.511H16.0572C19.5192 21.511 21.5831 19.4471 21.5831 15.9852V8.01502C21.5926 4.55306 19.5287 2.4892 16.0668 2.4892ZM15.6483 15.5667H8.51511C8.12516 15.5667 7.80179 15.2433 7.80179 14.8534C7.80179 14.4634 8.12516 14.14 8.51511 14.14H15.6483C16.0382 14.14 16.3616 14.4634 16.3616 14.8534C16.3616 15.2433 16.0382 15.5667 15.6483 15.5667ZM15.6483 9.86014H8.51511C8.12516 9.86014 7.80179 9.53677 7.80179 9.14682C7.80179 8.75687 8.12516 8.4335 8.51511 8.4335H15.6483C16.0382 8.4335 16.3616 8.75687 16.3616 9.14682C16.3616 9.53677 16.0382 9.86014 15.6483 9.86014Z" fill="#292D32" /> </svg> Order Details</h5>
            </div>
            <div className="widget-body">
              <div className="order-detail-item">
                <h4>Buyer Name:</h4>
                <p>{orderInfo?.userDetails?.name}</p>
              </div>
              <div className="order-detail-item">
                <h4>Order ID:</h4>
                <p><button><svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.33317 6.41252V8.33752C7.33317 9.94169 6.6915 10.5834 5.08734 10.5834H3.16234C1.55817 10.5834 0.916504 9.94169 0.916504 8.33752V6.41252C0.916504 4.80835 1.55817 4.16669 3.16234 4.16669H5.08734C6.6915 4.16669 7.33317 4.80835 7.33317 6.41252Z" stroke="#0877FF" stroke-width="1.38426" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10.0832 3.66246V5.58746C10.0832 7.19163 9.4415 7.83329 7.83734 7.83329H7.33317V6.41246C7.33317 4.80829 6.6915 4.16663 5.08734 4.16663H3.6665V3.66246C3.6665 2.05829 4.30817 1.41663 5.91234 1.41663H7.83734C9.4415 1.41663 10.0832 2.05829 10.0832 3.66246Z" stroke="#0877FF" stroke-width="1.38426" stroke-linecap="round" stroke-linejoin="round" /> </svg> </button> {orderInfo?._id}</p>
              </div>
              <div className="order-detail-item">
                <h4>SKU ID:</h4>
                <p><button><svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.33317 6.41252V8.33752C7.33317 9.94169 6.6915 10.5834 5.08734 10.5834H3.16234C1.55817 10.5834 0.916504 9.94169 0.916504 8.33752V6.41252C0.916504 4.80835 1.55817 4.16669 3.16234 4.16669H5.08734C6.6915 4.16669 7.33317 4.80835 7.33317 6.41252Z" stroke="#0877FF" stroke-width="1.38426" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10.0832 3.66246V5.58746C10.0832 7.19163 9.4415 7.83329 7.83734 7.83329H7.33317V6.41246C7.33317 4.80829 6.6915 4.16663 5.08734 4.16663H3.6665V3.66246C3.6665 2.05829 4.30817 1.41663 5.91234 1.41663H7.83734C9.4415 1.41663 10.0832 2.05829 10.0832 3.66246Z" stroke="#0877FF" stroke-width="1.38426" stroke-linecap="round" stroke-linejoin="round" /> </svg> </button> TS12345</p>
              </div>
            </div>
          </div>

          <div className="orderItem">
            <p>Order Number: 12345676789</p>
            <div className="order-detail-row">
              <figure>
                <img src="https://placehold.co/150" alt="" />
              </figure>
              <div className="order-detail">
                <p>Retrograph - Espresso</p>
                <p className="variant"><strong>Variant:</strong> Blue/Large</p>
                <p className="variant"><strong>Unit Price:</strong> Rs. 255.00</p>
                <p className="variant"><strong>QTY:</strong> <div className="qty-box">1</div></p>
              </div>
            </div>

            <div className="order-sub-detail-row">
              <h4>Total Purchase:</h4>
              <p>Rs. 107,000</p>
            </div>
            <div className="order-sub-detail-row">
              <h4>Print:</h4>
              <p><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z" className="fill" /> <path d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z" className="fill" /> <path d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z" className="fill" /> </svg> Invoice</p>
              <p><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z" className="fill" /> <path d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z" className="fill" /> <path d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z" className="fill" /> </svg> Picklist</p>
              <p><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z" className="fill" /> <path d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z" className="fill" /> <path d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z" className="fill" /> </svg> AWB</p>
              <p className="inactive"><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M5.27002 3.47806C5.27002 2.40572 6.13564 1.5401 7.20798 1.5401H9.79193C10.8643 1.5401 11.7299 2.40572 11.7299 3.47806C11.7299 3.83336 11.4392 4.12405 11.0839 4.12405H5.91601C5.56071 4.12405 5.27002 3.83336 5.27002 3.47806Z" className="fill" /> <path d="M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z" className="fill" /> <path d="M12.3759 4.77008H4.624C3.33202 4.77008 2.68604 5.41607 2.68604 6.70804V9.93798C2.68604 11.23 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6952 5.26999 11.4722V11.4722C5.26999 11.2492 5.08349 11.0752 4.87491 10.9964C4.44712 10.8347 4.13951 10.4195 4.13951 9.93798C4.13951 9.31783 4.64984 8.8075 5.26999 8.8075H11.7299C12.35 8.8075 12.8603 9.31783 12.8603 9.93798C12.8603 10.4195 12.5527 10.8347 12.1249 10.9964C11.9164 11.0752 11.7299 11.2492 11.7299 11.4722V11.4722C11.7299 11.6952 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.23 14.3138 9.93798V6.70804C14.3138 5.41607 13.6678 4.77008 12.3759 4.77008ZM7.20795 7.83852H5.26999C5.00513 7.83852 4.7855 7.61889 4.7855 7.35403C4.7855 7.08918 5.00513 6.86954 5.26999 6.86954H7.20795C7.4728 6.86954 7.69244 7.08918 7.69244 7.35403C7.69244 7.61889 7.4728 7.83852 7.20795 7.83852Z" className="fill" /> </svg> Rider Handover</p>
            </div>
          </div>

          <div className="widget">
            <div className="widget-header">
              <h5><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M17.2798 6.82164C16.2811 2.42761 12.4482 0.449341 9.08139 0.449341C9.08139 0.449341 9.08139 0.449341 9.07188 0.449341C5.71454 0.449341 1.87214 2.4181 0.873494 6.81213C-0.239281 11.7197 2.76616 15.876 5.48628 18.4915C6.49443 19.4616 7.78791 19.9467 9.08139 19.9467C10.3749 19.9467 11.6684 19.4616 12.667 18.4915C15.3871 15.876 18.3926 11.7293 17.2798 6.82164ZM9.08139 11.5866C7.4265 11.5866 6.08546 10.2456 6.08546 8.59067C6.08546 6.93577 7.4265 5.59473 9.08139 5.59473C10.7363 5.59473 12.0773 6.93577 12.0773 8.59067C12.0773 10.2456 10.7363 11.5866 9.08139 11.5866Z" fill="#292D32" /> </svg> Shipping Address</h5>
            </div>
            <div className="widget-body">
              <div className="order-detail-item">
                <h4>Receiver Name:</h4>
                <p>M Maria</p>
              </div>
              <div className="order-detail-item">
                <h4>Receiver Phone No:</h4>
                <p><button><svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.33317 6.41252V8.33752C7.33317 9.94169 6.6915 10.5834 5.08734 10.5834H3.16234C1.55817 10.5834 0.916504 9.94169 0.916504 8.33752V6.41252C0.916504 4.80835 1.55817 4.16669 3.16234 4.16669H5.08734C6.6915 4.16669 7.33317 4.80835 7.33317 6.41252Z" stroke="#0877FF" stroke-width="1.38426" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10.0832 3.66246V5.58746C10.0832 7.19163 9.4415 7.83329 7.83734 7.83329H7.33317V6.41246C7.33317 4.80829 6.6915 4.16663 5.08734 4.16663H3.6665V3.66246C3.6665 2.05829 4.30817 1.41663 5.91234 1.41663H7.83734C9.4415 1.41663 10.0832 2.05829 10.0832 3.66246Z" stroke="#0877FF" stroke-width="1.38426" stroke-linecap="round" stroke-linejoin="round" /> </svg> </button> 9234567890</p>
              </div>
              <div className="order-detail-item">
                <h4>Address:</h4>
                <p>1234 Elm Street, Apt 567 Los <br></br>Angeles, CA 90001 United States</p>
              </div>
            </div>
          </div>

          <div className="widget">
            <div className="widget-header">
              <h5><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.7882 0.638123H4.37516C2.27325 0.638123 0.570801 2.33106 0.570801 4.41395V13.9819C0.570801 16.0648 2.27325 17.7577 4.37516 17.7577H15.7882C17.8901 17.7577 19.5926 16.0648 19.5926 13.9819V4.41395C19.5926 2.33106 17.8901 0.638123 15.7882 0.638123ZM6.75288 4.60416C7.96076 4.60416 8.9499 5.5933 8.9499 6.80118C8.9499 8.00906 7.96076 8.9982 6.75288 8.9982C5.545 8.9982 4.55586 8.00906 4.55586 6.80118C4.55586 5.5933 5.545 4.60416 6.75288 4.60416ZM10.4336 13.63C10.348 13.7251 10.2148 13.7822 10.0817 13.7822H3.42407C3.29092 13.7822 3.15776 13.7251 3.07217 13.63C2.98657 13.5349 2.93901 13.4017 2.94852 13.2686C3.11021 11.6708 4.38467 10.4058 5.9825 10.2536C6.48658 10.2061 7.00967 10.2061 7.51375 10.2536C9.11158 10.4058 10.3956 11.6708 10.5477 13.2686C10.5667 13.4017 10.5192 13.5349 10.4336 13.63ZM16.7393 13.7156H14.8371C14.4472 13.7156 14.1238 13.3922 14.1238 13.0023C14.1238 12.6123 14.4472 12.289 14.8371 12.289H16.7393C17.1293 12.289 17.4526 12.6123 17.4526 13.0023C17.4526 13.3922 17.1293 13.7156 16.7393 13.7156ZM16.7393 9.91124H12.935C12.545 9.91124 12.2216 9.58787 12.2216 9.19793C12.2216 8.80798 12.545 8.48461 12.935 8.48461H16.7393C17.1293 8.48461 17.4526 8.80798 17.4526 9.19793C17.4526 9.58787 17.1293 9.91124 16.7393 9.91124ZM16.7393 6.10689H11.9839C11.5939 6.10689 11.2706 5.78352 11.2706 5.39357C11.2706 5.00362 11.5939 4.68025 11.9839 4.68025H16.7393C17.1293 4.68025 17.4526 5.00362 17.4526 5.39357C17.4526 5.78352 17.1293 6.10689 16.7393 6.10689Z" fill="#292D32" /> </svg> Billing Address</h5>
            </div>
            <div className="widget-body">
              <div className="order-detail-item">
                <h4>Address:</h4>
                <p>1234 Elm Street, Apt 567 Los <br></br>Angeles, CA 90001 United States</p>
              </div>
            </div>
          </div>

          <div className="btnRow">
            <button className="btn btn-accept">Accept Order</button>
            <button className="btn btn-reject">Reject</button>
          </div>

        </div>
      </Container>
    </div>
  );
};

export default OrderDetail;